import styled from 'styled-components';
import {
  DropdownButton,
  Flex,
  IconTeamOutline,
  IconUserOutline,
  Menu,
  MenuContent,
  MenuItem,
  MenuPopper,
  Text,
} from '@zillow/constellation';

import type { Application } from '../../../../models/Types';
import { FULLSTORY_EXCLUDE } from '../../../../constants/analytics';

const StyledMenu = styled(Menu)`
  overflow-y: auto;
  max-height: 200px;
`;

type Props = {
  applicationList: Array<Application>;
  onAddApplicants: (application: Application) => void;
  disabled: boolean;
};

function ApplicantSelector({ applicationList, onAddApplicants, disabled }: Props) {
  function renderMenuText(applicants): string {
    const textArray = [];
    applicants.forEach((applicant) => {
      textArray.push(`${applicant.firstName} ${applicant.lastName}`);
    });
    return textArray.join(', ');
  }

  return (
    <>
      <MenuPopper
        triggered={
          <StyledMenu>
            <MenuContent>You can only select applicants who have completed their applications.</MenuContent>
            {applicationList.map((application: Application, index: number) => {
              const { applicants } = application;

              return (
                <MenuItem
                  onClick={onAddApplicants.bind(null, application)}
                  icon={applicants.length > 1 ? <IconTeamOutline /> : <IconUserOutline />}
                  key={index}
                  className={FULLSTORY_EXCLUDE}
                >
                  <Flex display="flex" flexDirection="column">
                    {renderMenuText(applicants)}
                  </Flex>
                </MenuItem>
              );
            })}
          </StyledMenu>
        }
      >
        <DropdownButton disabled={disabled} data-test="select-a-tenant-dropdown-btn">
          Select tenant(s)
        </DropdownButton>
      </MenuPopper>
      <Text marginX="sm" marginY={{ default: 'xs', lg_gte: 0 }}>
        or
      </Text>
    </>
  );
}

export default ApplicantSelector;
